// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__l1zCZ","summary":"CartItem_summary__B7Tra","price":"CartItem_price__CcSML","amount":"CartItem_amount__aw2kv","actions":"CartItem_actions__Dfu3B"};